import React, { useState, useRef, useEffect } from 'react'
import './features.css'
import { motion } from 'framer-motion'
const featureHeaderVariant = {
    hidden: {
        x: "-100vw",
        opacity: 0
    },
    visible: {
        x: 0,
        opacity: 1,
        transition: {
            delay: 0.5,
            duration: 1,
            when: "beforeChildren"
        }
    }
}
const cardVariant = {
    hidden: {
        y: "10vh",
        opacity: 0
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            delay: 1,
            duration: 2,
            type: "spring",
        }
    }
}
export default function Features() {
    const intersectionRef = useRef([]);
    const [isIntersect, setIsIntersect] = useState(false)
    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting){
                    setIsIntersect(true)
                } else {
                    setIsIntersect(false)
                }
            })
        }, {
            threshold: 0.3
        })
        intersectionRef.current.forEach((intersection) => {
           if(intersection) observer.observe(intersection)
        })
    }, [])
    return (
        <div className="feature-section" ref={el => intersectionRef.current[0] = el}>
            <motion.div className="heading"
                variants={featureHeaderVariant}
                initial="hidden"
                animate={isIntersect ? "visible" : "hidden"}>
                <h3>Forge your digital destiny</h3>
                <p> Our all-in-one platform offers seamless integration and management of your blockchain applications.</p>
            </motion.div>
            <motion.div className="features-details"
                variants={cardVariant}
                initial="hidden"
                animate={isIntersect ? "visible" : "hidden"}
                ref={el => intersectionRef.current[1] = el}>
                <div className="detail-card">
                    <div className="card-icon">
                        <i className='bx bx-qr-scan'></i>
                    </div>
                    <div className="card-text">
                        <h4 className="card-header">
                            Smart Contract Interaction
                        </h4>
                        <p className="card-paragraph">
                            Effortlessly deploy and interact with smart contracts on multiple blockchains.</p>
                    </div>
                </div>
                <div className="detail-card">
                    <div className="card-icon">
                        <i className='bx bxl-netlify'></i>
                    </div>
                    <div className="card-text">
                        <h4 className="card-header">
                            Token Management
                        </h4>
                        <p className="card-paragraph">
                            Manage your crypto portfolio with real-time price updates and transaction history.</p>
                    </div>
                </div>
                <div className="detail-card">
                    <div className="card-icon">
                        <i className='bx bxl-graphql'></i>
                    </div>
                    <div className="card-text">
                        <h4 className="card-header">
                            Decentralized Storage
                        </h4>
                        <p className="card-paragraph">
                            Securely store and share your files using IPFS technology for all transaction in-app.</p>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}
